import type { IProcessActivityReadSection } from '@common/interfaces/processActivityReadSection';
import type { TreatmentData } from '@common/validation/customControls/osas/osasAllTreatmentsSchemas/types';
import type {
    OsasTreatmentData,
    TreatmentFollowUpData,
} from '@common/validation/customControls/osas/osasTreatmentChoice/types';
import type { ComponentsMap } from '@frontend/formEngine/readForm/readForm.types';
import { getProcessActivityReadSectionItem } from '@common/utils/processActivityReadUtil';
import { OsasTreatmentRead } from '../components/treatmentFormSection/OsasTreatmentRead';

export function addOsasTreatmentSection<
    ReadData extends {
        cpapSetting: string;
        cpapSettingText: string;
        refer: OsasTreatmentData['refer'];
        shouldHaveFollowingExamination: boolean;
        shouldHaveFollowUpConsult: boolean;
        taskFollowingExaminationOrConsultWeeks: number;
        treatment: TreatmentData;
        treatmentFollowUp: TreatmentFollowUpData;
    },
>(readSections: IProcessActivityReadSection[], map: ComponentsMap): void {
    const treatmentItem = getProcessActivityReadSectionItem<ReadData>()(readSections, 'treatment');

    if (treatmentItem && Object.values(treatmentItem).some((value) => value !== null)) {
        const treatmentFollowUpItem = getProcessActivityReadSectionItem<ReadData>()(readSections, 'treatmentFollowUp');
        const cpapSetting = getProcessActivityReadSectionItem<ReadData>()(readSections, 'cpapSetting');
        const cpapSettingText = getProcessActivityReadSectionItem<ReadData>()(readSections, 'cpapSettingText');
        const referItems = getProcessActivityReadSectionItem<ReadData>()(readSections, 'refer');
        const shouldHaveFollowingExamination = getProcessActivityReadSectionItem<ReadData>()(
            readSections,
            'shouldHaveFollowingExamination'
        );
        const shouldHaveFollowUpConsult = getProcessActivityReadSectionItem<ReadData>()(
            readSections,
            'shouldHaveFollowUpConsult'
        );
        const taskFollowingExaminationOrConsultWeeks = getProcessActivityReadSectionItem<ReadData>()(
            readSections,
            'taskFollowingExaminationOrConsultWeeks'
        );

        map.set(
            treatmentItem.key,
            <OsasTreatmentRead
                cpapSetting={cpapSetting?.value}
                cpapSettingText={cpapSettingText?.value}
                refer={referItems?.value}
                shouldHaveFollowingExamination={shouldHaveFollowingExamination?.value}
                shouldHaveFollowUpConsult={shouldHaveFollowUpConsult?.value}
                taskFollowingExaminationOrConsultWeeks={taskFollowingExaminationOrConsultWeeks?.value}
                treatment={treatmentItem.value}
                treatmentFollowUps={treatmentFollowUpItem?.value}
            />
        );
    }
}
